import { DataSourceState, FSA } from '../types';
import {
  SEARCH_ACTION,
  SORT_ACTION,
  NEXT_PAGE_ACTION,
  PREV_PAGE_ACTION,
  SET_DATA_ACTION,
  SET_ERROR_ACTION,
  GO_TO_PAGE_ACTION,
  IS_LOADING_ACTION,
  SET_PAGE_SIZE_ACTION,
} from './constants';

export const initialState: DataSourceState = {
  currentPage: 1,
  totalPages: 1,
  count: 0,
  pageSize: 25,
  searchTerm: '',
  sortBy: {},
  items: [],
  isLoading: true,
  error: null,
};

export const dataReducer = (
  state: DataSourceState,
  action: FSA<any>,
): DataSourceState => {
  switch (action.type) {
    case NEXT_PAGE_ACTION:
      return {
        ...state,
        currentPage:
            state.currentPage < (state.totalPages || 1)
              ? state.currentPage + 1
              : state.currentPage,
      };
    case PREV_PAGE_ACTION:
      return {
        ...state,
        currentPage: state.currentPage === 1 ? 1 : state.currentPage - 1,
      };
    case GO_TO_PAGE_ACTION:
      return {
        ...state,
        currentPage: action.payload > 0 ? action.payload : state.currentPage,
      };
    case SEARCH_ACTION:
      return { ...state, searchTerm: action.payload, currentPage: 1 };
    case SORT_ACTION:
      return { ...state, sortBy: action.payload, currentPage: 1 };
    case IS_LOADING_ACTION:
      return { ...state, isLoading: action.payload };
    case SET_DATA_ACTION:
      return {
        ...state,
        items: action.payload.items,
        count: action.payload.count,
        error: null,
        isLoading: false,
        currentPage: action.payload.page ?? state.currentPage,
        totalPages: action.payload.totalPages ?? 1,
      };
    case SET_ERROR_ACTION:
      return {
        ...state, error: action.payload, items: [], isLoading: false,
      };
    case SET_PAGE_SIZE_ACTION:
      return { ...state, pageSize: action.payload ?? state.pageSize, currentPage: 1 };
    default:
      return state;
  }
};
